import { useFormContext } from "react-hook-form"

function Select({ name, options }) {
  const { register } = useFormContext()

  return (
    <div className="relative w-full">
      <select
        id={name}
        {...register(name)}
        className="block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline">
        {options.map((option) => (
          <option key={option?.key ?? option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
        <svg
          className="w-4 h-4 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>
  )
}

export default Select
